


































































































































































import { Component, Vue } from "vue-property-decorator";
import { AccountService } from "@/core/services";
import { ProgramOverviewImageDialogCpt, GreetingMessageCpt } from "@/core/components";
import { images } from "@/core/constants";
import AppVue from "../AppVue.vue";

@Component({
  components: {
    ProgramOverviewImageDialogCpt,
    GreetingMessageCpt,
  },
})
export default class HomeView extends AppVue {
  isAttendanceRecorded = false;
  showImageDialog = false;

  async created() {
    this.isAttendanceRecorded = await AccountService.isAttendanceRecorded();
  }

  get programOverviewImgUrl() {
    return images.programOverview;
  }

  get preReadingImgUrl() {
    return images.preReadingImgUrl;
  }

  get workshopTemplatesImgUrl() {
    return images.workshopTemplatesImgUrl;
  }

  get workshopMaterialsImgUrl() {
    return images.workshopMaterialsImgUrl;
  }

  get strategyClarificationWorkshopImgUrl() {
    return images.strategyClarificationWorkshopImgUrl;
  }

  get preReading() {
    return require("@/styles/files/So-you-think-you-have-a-strategy PRE READING.pdf");
  }

  get workshopTemplates() {
    return require("@/styles/files/Spotlight on skills Workshop Templates.pptx");
  }

  get workshopMaterials() {
    return require("@/styles/files/SOS Slide Deck for App.pptx");
  }

  get strategyClarificationWorkshop() {
    return require("@/styles/files/SOS Strategy Clarification.pptx");
  }
}
